import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

// Animations
import { openClose, popUp } from './animations';

// Services
import { MenuStoreService } from 'src/app/services/menu-store/menu-store.service';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LoginService } from 'src/app/services/login/login.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

// Models
import { Purchase2 } from 'src/app/models/purchase2';
import { Payment } from 'src/app/models/payment';

import toastr from "toastr";

@Component({
  selector: 'app-btn-payment',
  templateUrl: './btn-payment.component.html',
  styleUrls: ['./btn-payment.component.sass'],
  animations: [
    openClose,
    popUp
  ]
})
export class BtnPaymentComponent implements OnInit {

  listSubcriptions: Subscription[] = [];

  isOpen: boolean = false

  purchase: Purchase2 = new Purchase2();

  showBtnPayment: boolean = false;

  showPopUp: boolean = false;

  constructor(
    private _menuStoreService: MenuStoreService,
    private _checkoutService: CheckoutService,
    private _sharedService: SharedService,
    private _loginService: LoginService,
    private _mainService: MainService,
    private _amplitudeService: AmplitudeService
  ) { }

  ngOnInit(): void {
    this.listenerGetPurchase();
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  openClose(): void {
    this.isOpen = !this.isOpen
    if(this.isOpen) this.getPurchase();
  }

  selectPaymentMethod(payment: Payment): void {
    if(this.purchase.paymentStatus != 'Pagado'){
      this.purchase.paymentMethods.map(p => p.selected = false)
      payment.selected = true;
      payment.id == 3 ? this.showBtnPayment = true : this.showBtnPayment = false;
      this.updateWayToPay(payment);
    } else {
      toastr.warning('Opción no valida, la factura fue pagada.');
    }
  }

  async updateWayToPay(payment: Payment) {
    
    let data = {
      way_to_pay_id: payment.id,
      table_number: localStorage.getItem('table_user'),
      modality: localStorage.getItem('modality'),
    }
    this._sharedService.emmiterShowLoader(true);
    let response: any = await this._checkoutService.updateAddress(data).toPromise()
      .catch((err: any) => {
        this._sharedService.emmiterShowLoader(false);
        console.log('Error al actualizar metodo de pago.');
      });
    this._sharedService.emmiterShowLoader(false);
    if( response ){
      this.purchase.wayToPayId = payment.id;
      this.purchase.wayToPayName = payment.description;
    }
    this._amplitudeService.emmiterLogEvent('UPDATE_WAY_TO_PAY', {
      PAYMENT_ID: payment.id,
      PAYMENT_NAME: payment.description
    });
  
  }

  async updateTip(payment: Payment) {
    if(this.purchase.paymentStatus != 'Pagado'){
      let data = {
        tip: this.purchase.tipPrice == 0 ? true : false,
        table_number: localStorage.getItem('table_user'),
        modality: localStorage.getItem('modality'),
      }
      this._sharedService.emmiterShowLoader(true);
      let response: any = await this._checkoutService.updateAddress(data).toPromise()
        .catch((err: any) => {
          this._sharedService.emmiterShowLoader(false);
          console.log('Error al actualizar propina.');
        });
      this._sharedService.emmiterShowLoader(false);
      this._amplitudeService.emmiterLogEvent('UPDATE_TIP', {
        TIP: this.purchase.tipPrice == 0 ? true : false
      });
      this.getPurchase()
    } else {
      toastr.warning('La factura fue pagada.');
    }
  }

  async getUrlPayment() {
    this._sharedService.emmiterShowLoader(true)
    let modality = localStorage.getItem('modality')
    let route = '/';
    if(modality == 'salon'){
      let clientId  = localStorage.getItem('clientId')
      let companyId = localStorage.getItem('companyId')
      let table  = localStorage.getItem('table_user')
      let host = window.location.origin
      route = `${host}/#/menu/empresa/${clientId}/compania/${companyId}/modalidad/salon/mesa/${table}`;
    }
    let data = {
      redirect_url: route
    }
    let response: any = await this._menuStoreService.getUrlPayment(data).toPromise()
      .catch((err: any) => {
          if (err.error.data.message) {
            this._sharedService.emmiterShowLoader(false)
            toastr.warning(err.error.data.message);
            console.log(err.error.data.message);
          }
        });
      this._sharedService.emmiterShowLoader(false)
      if (response && response.data) {
        if (response.data.status == 0) {
          window.location.href = response.data.form_url;
          this._amplitudeService.emmiterLogEvent('OPEN_PAYMENT_GATEWAY', {
            URL: response.data.form_url
          });
        }
        if (response.data.status == 1) {
          if (confirm('Su pago fue rechazado \n ¿Desea reintentar?')) {
            this._amplitudeService.emmiterLogEvent('TRY_TO_PAY_AGAIN', {
              URL: response.data.form_url
            });
            window.location.href = response.data.form_url;
          } else {
            this._amplitudeService.emmiterLogEvent('DO_NOT_TRY_TO_PAY_AGAIN', {});
            // this.validatingPayment = false;
          }
        }
        if (response.data.status == 2) {
          this._amplitudeService.emmiterLogEvent('PAYMENT_ACCEPTED', {});
          toastr.success('El pago fue exitoso');
          this.openClose();
          setTimeout(() => {
            window.location.href = '/'
          }, 500);
        }
      }
  }

  async getPurchase() {

    let data: any = {
      modality: localStorage.getItem('modality'),
      company: localStorage.getItem('companyId'),
      client: localStorage.getItem('clientId'),
      table: localStorage.getItem('table_user')
    }

    let response: any = await this._mainService.getListCategories( data ).toPromise().catch((err: any) => this.handleError(err));
    if( response && response.data && response.data.compra ){
      this.purchase = new Purchase2(response.data.compra)
      this.selectPaymentMethodByDefault();
    }
    this._amplitudeService.emmiterLogEvent('OPEN_PAY_ORDER', {
      PURCHASE_ID: this.purchase.id,
      TOTAL: this.purchase.total,
      PRODUCTS_LENGTH: this.purchase.products.length
    });
    this.createTemporaryUser();
  }

  handleError(error: any): void {
    console.log(error);
    
    // if(error.error.message) console.log(error.error.message);
  }

  payInStore(): void {
    this.showPopUp = true;
    setTimeout(()=>{
      window.location.href = '/'
    }, 4000)
    // if(this.purchase.paymentStatus == 'Pagado'){
    //   this._sharedService.closeSession();
    // } else {
    //   toastr.warning('Valide el pago con el mesero.');
    // }
  }

  selectPaymentMethodByDefault(): void {
    this.purchase.paymentMethods.map(payment => payment.id == this.purchase.wayToPayId ? payment.selected = true : null)
    if(this.purchase.wayToPayId == 3) this.showBtnPayment = true;
  }

  async createTemporaryUser() {
    if(!this._sharedService.validSession()){
      this._sharedService.emmiterShowLoader(true)
      let data = {
        name: "Invitado",
        modality: localStorage.getItem('modality'),
        company_id: localStorage.getItem('companyId')
      };
      let response: any = await this._loginService.createUserTemporary(data).toPromise()
      .catch((err: any) => {
        if(err.error.message) toastr.warning(err.error.message);
        this._sharedService.emmiterShowLoader(false)
      });
      this._sharedService.emmiterShowLoader(false)
      if( response && response.sesion ){
        console.log(response);
        localStorage.setItem('uid',        response.sesion.user_id)
        localStorage.setItem('token',      response.sesion.token)
        localStorage.setItem('session','true')
      }
    }
  }

  listenerGetPurchase(): void {
    this.listSubcriptions.push(
      this._menuStoreService.getSubjetPurchase().asObservable().subscribe(
        (purchase: Purchase2) => {
          this.purchase = purchase;
          this.selectPaymentMethodByDefault();
          this.createTemporaryUser();
        }
      )
    );
  }

}
